import { BreadcrumbViewModel } from "../openapi/webservice";

export function getContextName(breadcrumb: BreadcrumbViewModel) {
    return `${breadcrumb.designContextName} \u2013 ${breadcrumb.subContextName}`;
}

export function removeLineBreaks(value: string) {
    return value.replace(/\r?\n|\r/gm, " ");
}
